// ./.env.json is added to the bundle by the build process
/*eslint import/no-unresolved: [2, { ignore: ['./.env.json'] }]*/

import axios from 'axios';
import {InferType, object, string, boolean, ValidationError} from 'yup';

const configSchema = object({
  sentryEnvironment: string().required(),
  sentryDSN: string().defined(),
  apiOrigin: string().required(),
  uploadsOrigin: string().required(),
  apiContactOrigin: string().required(),
  wmsOrigin: string().required(),
  wmsCSOrigin: string().required(),
  wfsOrigin: string().required(),
  selfOrigin: string().required(),
  streetViewImageOrigin: string().required(),
  isProduction: boolean().required(),
  googleMapsApiKey: string().required(),
  anonymousPluAutoApiKey: string(),
  autodeskClientId: string(),
  amplitudeApiKey: string(),
  canSeeFeatureFlags: boolean().nullable().default(false),
  pluAutoLambdaSuffix: string().nullable(),
  datadogRumAppId: string().nullable(),
  datadogRumClientToken: string().nullable(),
  datadogRumServiceName: string().nullable(),
  oneClickLCAIntegrationSecurityToken: string(),
  gatewayHost: string().default(''),
});

export type BuildrzConfig = InferType<typeof configSchema>;

export function getValidConfig(config: unknown): BuildrzConfig {
  try {
    return configSchema.validateSync(config, {abortEarly: false});
  } catch (err) {
    if (ValidationError.isError(err)) {
      console.error(err.errors);
    } else {
      console.error('Unknown validation error');
    }
    throw new Error('Invalid configuration');
  }
}

let _config: BuildrzConfig;

async function loadConfigFromBundle(): Promise<BuildrzConfig> {
  // ./.env.json is added to the bundle by the build process
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const config = (await import('./.env.json')).default;
  return setConfigFromJSON(getValidConfig(config));
}

export async function loadConfig(): Promise<BuildrzConfig> {
  if (_config) {
    return _config;
  }

  if (typeof window !== 'undefined') {
    try {
      const data = await axios.get(`/.env.json?timestamp=${Date.now()}`);
      return setConfigFromJSON(getValidConfig(data.data));
    } catch {
      return await loadConfigFromBundle();
    }
  } else {
    return await loadConfigFromBundle();
  }
}

export function setConfigFromJSON(config: BuildrzConfig): BuildrzConfig {
  _config = config;
  return config;
}

export default function getConfig(): BuildrzConfig {
  if (!_config) {
    throw new Error('Config not loaded');
  }

  return _config;
}
